import React, {useEffect, useState, useContext} from "react";
import * as Sentry from '@sentry/browser';
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import { Wrapper, Container, Column } from "../../hoc/Layout";
import Pagination from "react-js-pagination";
import MerchantTerminalSelect from "../../Components/MerchantTerminalSelect";
import DateRange from "../../Components/Utils/DateRange";
import MessageContext from "../../MessageContext";

import classes from "./styles.module.css";

var STATUS_LABELS = {
    0: "Создан",
    1: "Подтверждён",
    2: "Отменён"
};

function getStatusBadgeClass(status) {
    switch (status) {
        case 0:
            return classes.BadgeCreated;
        case 1:
            return classes.BadgeConfirmed;
        case 2:
            return classes.BadgeCancelled;
        default:
            return classes.Badge;
    }
}

function formatAmount(amountInKopecks) {
    if (amountInKopecks === null || amountInKopecks === undefined) return "0.00";
    return (Number(amountInKopecks) / 100).toLocaleString("ru-RU", {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

function formatDate(dateStr) {
    if (!dateStr) return "\u2014";
    try {
        var d = new Date(dateStr);
        return d.toLocaleString("ru-RU");
    } catch (e) {
        return dateStr;
    }
}

var Settlement = withAuth(function (props) {
    var token = props.token;
    var onMessage = useContext(MessageContext).onMessage;

    // List state
    var _settlements = useState([]);
    var settlements = _settlements[0];
    var setSettlements = _settlements[1];

    var _count = useState(0);
    var count = _count[0];
    var setCount = _count[1];

    var _loading = useState(false);
    var loading = _loading[0];
    var setLoading = _loading[1];

    var _page = useState(1);
    var page = _page[0];
    var setPage = _page[1];

    var _terminalId = useState("");
    var terminalId = _terminalId[0];
    var setTerminalId = _terminalId[1];

    var _statusFilter = useState("");
    var statusFilter = _statusFilter[0];
    var setStatusFilter = _statusFilter[1];

    // Detail state
    var _selectedSettlement = useState(null);
    var selectedSettlement = _selectedSettlement[0];
    var setSelectedSettlement = _selectedSettlement[1];

    var _detailLoading = useState(false);
    var detailLoading = _detailLoading[0];
    var setDetailLoading = _detailLoading[1];

    // Create wizard state
    var _showCreate = useState(false);
    var showCreate = _showCreate[0];
    var setShowCreate = _showCreate[1];

    var _createTerminalId = useState("");
    var createTerminalId = _createTerminalId[0];
    var setCreateTerminalId = _createTerminalId[1];

    var _createDateRange = useState({});
    var createDateRange = _createDateRange[0];
    var setCreateDateRange = _createDateRange[1];

    var _createComment = useState("");
    var createComment = _createComment[0];
    var setCreateComment = _createComment[1];

    var _previewData = useState(null);
    var previewData = _previewData[0];
    var setPreviewData = _previewData[1];

    var _previewLoading = useState(false);
    var previewLoading = _previewLoading[0];
    var setPreviewLoading = _previewLoading[1];

    var _creating = useState(false);
    var creating = _creating[0];
    var setCreating = _creating[1];

    var _createUsdtRate = useState("");
    var createUsdtRate = _createUsdtRate[0];
    var setCreateUsdtRate = _createUsdtRate[1];

    var _createFile = useState(null);
    var createFile = _createFile[0];
    var setCreateFile = _createFile[1];

    // Excluded transaction IDs
    var _excludedIds = useState({});
    var excludedIds = _excludedIds[0];
    var setExcludedIds = _excludedIds[1];

    // Add/remove transactions state
    var _selectedTxIds = useState({});
    var selectedTxIds = _selectedTxIds[0];
    var setSelectedTxIds = _selectedTxIds[1];

    var _removeLoading = useState(false);
    var removeLoading = _removeLoading[0];
    var setRemoveLoading = _removeLoading[1];

    var _showAddModal = useState(false);
    var showAddModal = _showAddModal[0];
    var setShowAddModal = _showAddModal[1];

    var _addMode = useState("id");
    var addMode = _addMode[0];
    var setAddMode = _addMode[1];

    var _addIdInput = useState("");
    var addIdInput = _addIdInput[0];
    var setAddIdInput = _addIdInput[1];

    var _addSearchFilters = useState({dateFrom: "", dateTo: "", amountMin: "", amountMax: ""});
    var addSearchFilters = _addSearchFilters[0];
    var setAddSearchFilters = _addSearchFilters[1];

    var _addSearchResults = useState([]);
    var addSearchResults = _addSearchResults[0];
    var setAddSearchResults = _addSearchResults[1];

    var _addSelectedIds = useState({});
    var addSelectedIds = _addSelectedIds[0];
    var setAddSelectedIds = _addSelectedIds[1];

    var _addLoading = useState(false);
    var addLoading = _addLoading[0];
    var setAddLoading = _addLoading[1];

    // Cancel state
    var _cancelId = useState(null);
    var cancelId = _cancelId[0];
    var setCancelId = _cancelId[1];

    var _cancelReason = useState("");
    var cancelReason = _cancelReason[0];
    var setCancelReason = _cancelReason[1];

    var _cancelling = useState(false);
    var cancelling = _cancelling[0];
    var setCancelling = _cancelling[1];

    var perPage = 20;

    // Load settlements list
    useEffect(function () {
        loadSettlements();
    }, [page, terminalId, statusFilter, token]);

    function loadSettlements() {
        setLoading(true);
        var filters = {
            page: page,
            limit: perPage
        };
        if (terminalId) filters.terminal_id = terminalId;
        if (statusFilter !== "") filters.status = statusFilter;

        new Api({token: token}).getSettlements(filters).then(function (r) {
            setSettlements(Array.isArray(r.data) ? r.data : []);
            setCount(typeof r.count === "number" ? r.count : 0);
            setLoading(false);
        }).catch(function (err) {
            Sentry.captureException(err);
            setSettlements([]);
            setCount(0);
            setLoading(false);
            onMessage({type: "error", message: "Ошибка загрузки списка расчётов"});
        });
    }

    function loadDetail(id) {
        setDetailLoading(true);
        new Api({token: token}).getSettlementDetail(id).then(function (r) {
            setSelectedSettlement(r.data || r);
            setDetailLoading(false);
        }).catch(function (err) {
            Sentry.captureException(err);
            setDetailLoading(false);
            onMessage({type: "error", message: "Ошибка загрузки деталей расчёта"});
        });
    }

    function onPreview() {
        if (!createTerminalId) {
            onMessage({type: "error", message: "Укажите ID терминала"});
            return;
        }
        setPreviewLoading(true);
        setExcludedIds({});
        var data = {
            terminal_id: Number(createTerminalId)
        };
        if (createDateRange.startDate) data.date_from = createDateRange.startDate;
        if (createDateRange.endDate) data.date_to = createDateRange.endDate;

        new Api({token: token}).previewSettlement(data).then(function (r) {
            setPreviewData(r.data || r);
            setPreviewLoading(false);
        }).catch(function (err) {
            Sentry.captureException(err);
            setPreviewLoading(false);
            onMessage({type: "error", message: "Ошибка при превью расчёта"});
        });
    }

    function onCreate() {
        if (!createTerminalId) return;
        if (!previewData || !Array.isArray(previewData.transactions) || previewData.transactions.length === 0) {
            onMessage({type: "error", message: "Сначала выполните предпросмотр"});
            return;
        }
        setCreating(true);
        var transactionIds = previewData.transactions
            .filter(function (tx) { return !excludedIds[tx.id]; })
            .map(function (tx) { return tx.id; });
        if (transactionIds.length === 0) {
            onMessage({type: "error", message: "Все транзакции исключены"});
            setCreating(false);
            return;
        }
        var api = new Api({token: token});
        var promise;

        if (createFile) {
            var formData = new FormData();
            formData.append("terminal_id", Number(createTerminalId));
            formData.append("transaction_ids", JSON.stringify(transactionIds));
            formData.append("comment", createComment || "");
            if (createUsdtRate) formData.append("usdt_rate", createUsdtRate);
            formData.append("payment_proof", createFile);
            promise = api.createSettlementMultipart(formData);
        } else {
            var data = {
                terminal_id: Number(createTerminalId),
                transaction_ids: transactionIds,
                comment: createComment || ""
            };
            if (createUsdtRate) data.usdt_rate = createUsdtRate;
            promise = api.createSettlement(data);
        }

        promise.then(function () {
            setCreating(false);
            setShowCreate(false);
            setPreviewData(null);
            setCreateTerminalId("");
            setCreateDateRange({});
            setCreateComment("");
            setCreateUsdtRate("");
            setCreateFile(null);
            setExcludedIds({});
            setPage(1);
            loadSettlements();
            onMessage({type: "success", message: "Расчёт успешно создан"});
        }).catch(function (err) {
            Sentry.captureException(err);
            setCreating(false);
            onMessage({type: "error", message: "Ошибка при создании расчёта"});
        });
    }

    function onCancel() {
        if (!cancelId) return;
        setCancelling(true);
        var currentCancelId = cancelId;
        new Api({token: token}).cancelSettlement(currentCancelId, {reason: cancelReason}).then(function () {
            setCancelling(false);
            setCancelId(null);
            setCancelReason("");
            if (selectedSettlement && selectedSettlement.id === currentCancelId) {
                loadDetail(currentCancelId);
            }
            loadSettlements();
            onMessage({type: "success", message: "Расчёт отменён"});
        }).catch(function (err) {
            Sentry.captureException(err);
            setCancelling(false);
            onMessage({type: "error", message: "Ошибка при отмене расчёта"});
        });
    }

    function onRowClick(settlement) {
        loadDetail(settlement.id);
    }

    function onBackToList() {
        setSelectedSettlement(null);
        setSelectedTxIds({});
    }

    function onRemoveTransactions(ids) {
        if (!selectedSettlement) return;
        setRemoveLoading(true);
        new Api({token: token}).removeSettlementTransactions(selectedSettlement.id, ids).then(function (r) {
            setSelectedSettlement(r);
            setSelectedTxIds({});
            setRemoveLoading(false);
            loadSettlements();
            onMessage({type: "success", message: "Транзакции удалены из расчёта"});
        }).catch(function (e) {
            Sentry.captureException(e);
            setRemoveLoading(false);
            var msg = (e.response && e.response.data && e.response.data.message) || "Ошибка при удалении";
            onMessage({type: "error", message: msg});
        });
    }

    function onAddTransactions(ids) {
        if (!selectedSettlement) return;
        setAddLoading(true);
        new Api({token: token}).addSettlementTransactions(selectedSettlement.id, ids).then(function (r) {
            setSelectedSettlement(r);
            setShowAddModal(false);
            setAddLoading(false);
            loadSettlements();
            onMessage({type: "success", message: "Транзакции добавлены в расчёт"});
        }).catch(function (e) {
            Sentry.captureException(e);
            setAddLoading(false);
            var msg = (e.response && e.response.data && e.response.data.message) || "Ошибка при добавлении";
            onMessage({type: "error", message: msg});
        });
    }

    function onSearchForAdd() {
        if (!selectedSettlement) return;
        setAddLoading(true);
        var data = {
            terminal_id: Number(selectedSettlement.terminal_id)
        };
        if (addSearchFilters.dateFrom) data.date_from = addSearchFilters.dateFrom;
        if (addSearchFilters.dateTo) data.date_to = addSearchFilters.dateTo;

        new Api({token: token}).previewSettlement(data).then(function (r) {
            var txs = (r.data || r).transactions || [];
            if (addSearchFilters.amountMin) {
                var min = Number(addSearchFilters.amountMin) * 100;
                txs = txs.filter(function (t) { return t.amount >= min; });
            }
            if (addSearchFilters.amountMax) {
                var max = Number(addSearchFilters.amountMax) * 100;
                txs = txs.filter(function (t) { return t.amount <= max; });
            }
            setAddSearchResults(txs);
            setAddLoading(false);
        }).catch(function (err) {
            Sentry.captureException(err);
            setAddLoading(false);
            onMessage({type: "error", message: "Ошибка поиска транзакций"});
        });
    }

    function openCreateWizard() {
        setShowCreate(true);
        setPreviewData(null);
        setCreateTerminalId("");
        setCreateDateRange({});
        setCreateComment("");
        setCreateUsdtRate("");
        setCreateFile(null);
        setExcludedIds({});
    }

    function closeCreateWizard() {
        setShowCreate(false);
        setPreviewData(null);
    }

    // Render detail view
    function renderDetail() {
        if (!selectedSettlement) return null;
        var s = selectedSettlement;
        var transactions = Array.isArray(s.transactions) ? s.transactions : [];

        return (
            <div className={classes.Card}>
                {detailLoading && (
                    <div className={classes.Overlay}>Загрузка...</div>
                )}
                <div className={classes.Header}>
                    <div>
                        <span className={classes.BackLink} onClick={onBackToList}>
                            &larr; Назад к списку
                        </span>
                        <h5 className={classes.Title} style={{marginTop: 8}}>
                            {"Расчёт #" + s.id}
                        </h5>
                    </div>
                    <div style={{display: "flex", gap: 8}}>
                        {s.status !== 2 && (
                            <button
                                className={classes.BtnOutline}
                                onClick={function () {
                                    setShowAddModal(true);
                                    setAddMode("id");
                                    setAddIdInput("");
                                    setAddSearchResults([]);
                                    setAddSelectedIds({});
                                    setAddSearchFilters({dateFrom: "", dateTo: "", amountMin: "", amountMax: ""});
                                }}
                            >
                                Добавить транзакции
                            </button>
                        )}
                        {s.status === 1 && (
                            <button
                                className={classes.BtnDanger}
                                onClick={function () {
                                    setCancelId(s.id);
                                    setCancelReason("");
                                }}
                            >
                                Отменить
                            </button>
                        )}
                    </div>
                </div>

                <div className={classes.Content}>
                    <div className={classes.DetailGrid}>
                        <div>
                            <div className={classes.DetailLabel}>Мерчант</div>
                            <div className={classes.DetailValue}>{s.merchant_name || "\u2014"}</div>
                        </div>
                        <div>
                            <div className={classes.DetailLabel}>Терминал</div>
                            <div className={classes.DetailValue}>{s.terminal_name ? (s.terminal_name + " (#" + (s.terminal_id || s.terminalId) + ")") : (s.terminal_id || s.terminalId || "\u2014")}</div>
                        </div>
                        <div>
                            <div className={classes.DetailLabel}>Статус</div>
                            <div className={classes.DetailValue}>
                                <span className={getStatusBadgeClass(s.status)}>
                                    {STATUS_LABELS[s.status] || "Неизвестно"}
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className={classes.DetailLabel}>Сумма</div>
                            <div className={classes.DetailValue}>{formatAmount(s.amount)} &#8381;</div>
                        </div>
                        <div>
                            <div className={classes.DetailLabel}>Транзакций</div>
                            <div className={classes.DetailValue}>{s.transactions_count || s.transactionsCount || 0}</div>
                        </div>
                        <div>
                            <div className={classes.DetailLabel}>Дата создания</div>
                            <div className={classes.DetailValue}>{formatDate(s.created_at || s.createdAt)}</div>
                        </div>
                        <div>
                            <div className={classes.DetailLabel}>Создал</div>
                            <div className={classes.DetailValue}>{(s.created_by && s.created_by.username) || s.createdBy || "\u2014"}</div>
                        </div>
                        {s.usdt_rate && (
                            <div>
                                <div className={classes.DetailLabel}>Курс USDT</div>
                                <div className={classes.DetailValue}>{s.usdt_rate}</div>
                            </div>
                        )}
                        {s.amount_usdt != null && (
                            <div>
                                <div className={classes.DetailLabel}>Сумма USDT</div>
                                <div className={classes.DetailValue}>{Number(s.amount_usdt).toFixed(2)}</div>
                            </div>
                        )}
                    </div>

                    <div style={{display: "flex", gap: 8, marginBottom: 12}}>
                        {s.has_payment_proof && (
                            <button
                                className={classes.BtnOutline}
                                onClick={function () {
                                    new Api({token: token}).downloadSettlementPaymentProof(s.id);
                                }}
                            >
                                Скачать подтверждение ({s.payment_proof_original_name || "файл"})
                            </button>
                        )}
                        <button
                            className={classes.BtnOutline}
                            onClick={function () {
                                new Api({token: token}).downloadSettlementExcel(s.id);
                            }}
                        >
                            Скачать Excel
                        </button>
                    </div>

                    {s.comment && (
                        <div className={classes.DetailCard}>
                            <div className={classes.DetailLabel}>Комментарий</div>
                            <div style={{marginTop: 4}}>{s.comment}</div>
                        </div>
                    )}

                    {s.cancelled_reason && (
                        <div className={classes.DetailCard} style={{background: "#fff3cd", borderColor: "#ffc107"}}>
                            <div className={classes.DetailLabel}>Причина отмены</div>
                            <div style={{marginTop: 4}}>{s.cancelled_reason}</div>
                        </div>
                    )}

                    {transactions.length > 0 && (
                        <div>
                            <div style={{display: "flex", alignItems: "center", gap: 12, marginBottom: 8}}>
                                <h6 style={{margin: 0, fontWeight: 600}}>{"Транзакции (" + transactions.length + ")"}</h6>
                                {s.status !== 2 && Object.keys(selectedTxIds).length > 0 && (
                                    <button
                                        className={classes.BtnDanger}
                                        style={{fontSize: ".75rem", padding: "2px 10px"}}
                                        disabled={removeLoading}
                                        onClick={function () {
                                            if (!window.confirm("Удалить " + Object.keys(selectedTxIds).length + " транзакций из расчёта?")) return;
                                            onRemoveTransactions(Object.keys(selectedTxIds).map(Number));
                                        }}
                                    >
                                        {removeLoading ? "Удаление..." : "Удалить выбранные (" + Object.keys(selectedTxIds).length + ")"}
                                    </button>
                                )}
                            </div>
                            <table className={classes.Table}>
                                <thead>
                                <tr>
                                    {s.status !== 2 && (
                                        <th style={{width: 32}}>
                                            <input
                                                type="checkbox"
                                                checked={transactions.length > 0 && transactions.every(function (t) { return !!selectedTxIds[t.id]; })}
                                                onChange={function (e) {
                                                    var next = {};
                                                    if (e.target.checked) {
                                                        transactions.forEach(function (t) { next[t.id] = true; });
                                                    }
                                                    setSelectedTxIds(next);
                                                }}
                                            />
                                        </th>
                                    )}
                                    <th>ID</th>
                                    <th>Сумма</th>
                                    <th>Комиссия</th>
                                    <th>Дата</th>
                                    <th>Тип</th>
                                    {s.status !== 2 && <th style={{width: 40}}></th>}
                                </tr>
                                </thead>
                                <tbody>
                                {transactions.map(function (tx) {
                                    return (
                                        <tr key={tx.id}>
                                            {s.status !== 2 && (
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={!!selectedTxIds[tx.id]}
                                                        onChange={function (e) {
                                                            setSelectedTxIds(function (prev) {
                                                                var next = Object.assign({}, prev);
                                                                if (e.target.checked) next[tx.id] = true;
                                                                else delete next[tx.id];
                                                                return next;
                                                            });
                                                        }}
                                                    />
                                                </td>
                                            )}
                                            <td>{tx.id}</td>
                                            <td>{formatAmount(tx.amount)} &#8381;</td>
                                            <td>{formatAmount(tx.fee)} &#8381;</td>
                                            <td>{formatDate(tx.date)}</td>
                                            <td>{tx.type_name || tx.typeName || tx.type || "\u2014"}</td>
                                            {s.status !== 2 && (
                                                <td>
                                                    <button
                                                        className={classes.BtnDanger}
                                                        style={{fontSize: ".7rem", padding: "1px 6px", lineHeight: 1.4}}
                                                        title="Удалить из расчёта"
                                                        disabled={removeLoading}
                                                        onClick={function () {
                                                            if (!window.confirm("Удалить транзакцию #" + tx.id + " из расчёта?")) return;
                                                            onRemoveTransactions([tx.id]);
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {showAddModal && (
                        <div style={{position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <div style={{background: "#fff", borderRadius: 8, width: 700, maxHeight: "80vh", overflow: "auto", padding: 20}}>
                                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16}}>
                                    <h5 style={{margin: 0}}>{"Добавить транзакции в расчёт #" + s.id}</h5>
                                    <button className={classes.BtnOutline} onClick={function () { setShowAddModal(false); }}>&times;</button>
                                </div>

                                <div style={{display: "flex", gap: 12, marginBottom: 16}}>
                                    <button
                                        className={addMode === "id" ? classes.BtnPrimary : classes.BtnOutline}
                                        style={{fontSize: ".8125rem"}}
                                        onClick={function () { setAddMode("id"); }}
                                    >
                                        По ID
                                    </button>
                                    <button
                                        className={addMode === "search" ? classes.BtnPrimary : classes.BtnOutline}
                                        style={{fontSize: ".8125rem"}}
                                        onClick={function () { setAddMode("search"); }}
                                    >
                                        Поиск
                                    </button>
                                </div>

                                {addMode === "id" && (
                                    <div>
                                        <label style={{display: "block", fontSize: ".8125rem", marginBottom: 4}}>
                                            ID транзакций (через запятую):
                                        </label>
                                        <input
                                            type="text"
                                            value={addIdInput}
                                            onChange={function (e) { setAddIdInput(e.target.value); }}
                                            placeholder="12345, 12346, 12347"
                                            style={{width: "100%", padding: "6px 10px", border: "1px solid #ced4da", borderRadius: 4}}
                                        />
                                    </div>
                                )}

                                {addMode === "search" && (
                                    <div>
                                        <div style={{display: "flex", gap: 8, marginBottom: 8}}>
                                            <div style={{flex: 1}}>
                                                <label style={{fontSize: ".75rem"}}>Дата от</label>
                                                <input type="date" value={addSearchFilters.dateFrom}
                                                    onChange={function (e) { setAddSearchFilters(function (p) { return Object.assign({}, p, {dateFrom: e.target.value}); }); }}
                                                    style={{width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4}} />
                                            </div>
                                            <div style={{flex: 1}}>
                                                <label style={{fontSize: ".75rem"}}>Дата до</label>
                                                <input type="date" value={addSearchFilters.dateTo}
                                                    onChange={function (e) { setAddSearchFilters(function (p) { return Object.assign({}, p, {dateTo: e.target.value}); }); }}
                                                    style={{width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4}} />
                                            </div>
                                            <div style={{flex: 1}}>
                                                <label style={{fontSize: ".75rem"}}>Сумма от (руб)</label>
                                                <input type="number" value={addSearchFilters.amountMin}
                                                    onChange={function (e) { setAddSearchFilters(function (p) { return Object.assign({}, p, {amountMin: e.target.value}); }); }}
                                                    style={{width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4}} />
                                            </div>
                                            <div style={{flex: 1}}>
                                                <label style={{fontSize: ".75rem"}}>Сумма до (руб)</label>
                                                <input type="number" value={addSearchFilters.amountMax}
                                                    onChange={function (e) { setAddSearchFilters(function (p) { return Object.assign({}, p, {amountMax: e.target.value}); }); }}
                                                    style={{width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4}} />
                                            </div>
                                        </div>
                                        <button className={classes.BtnOutline} style={{fontSize: ".8125rem", marginBottom: 12}} disabled={addLoading} onClick={onSearchForAdd}>
                                            {addLoading ? "Поиск..." : "Найти"}
                                        </button>

                                        {addSearchResults.length > 0 && (
                                            <div style={{maxHeight: 300, overflow: "auto"}}>
                                                <table className={classes.Table}>
                                                    <thead>
                                                    <tr>
                                                        <th style={{width: 32}}>
                                                            <input type="checkbox"
                                                                checked={addSearchResults.length > 0 && addSearchResults.every(function (t) { return !!addSelectedIds[t.id]; })}
                                                                onChange={function (e) {
                                                                    var sel = {};
                                                                    if (e.target.checked) addSearchResults.forEach(function (t) { sel[t.id] = true; });
                                                                    setAddSelectedIds(sel);
                                                                }} />
                                                        </th>
                                                        <th>ID</th>
                                                        <th>Дата</th>
                                                        <th>Сумма</th>
                                                        <th>Тип</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {addSearchResults.map(function (tx) {
                                                        return (
                                                            <tr key={tx.id}>
                                                                <td>
                                                                    <input type="checkbox"
                                                                        checked={!!addSelectedIds[tx.id]}
                                                                        onChange={function (e) {
                                                                            setAddSelectedIds(function (p) {
                                                                                var n = Object.assign({}, p);
                                                                                if (e.target.checked) n[tx.id] = true; else delete n[tx.id];
                                                                                return n;
                                                                            });
                                                                        }} />
                                                                </td>
                                                                <td>{tx.id}</td>
                                                                <td>{formatDate(tx.date)}</td>
                                                                <td>{formatAmount(tx.amount)} &#8381;</td>
                                                                <td>{tx.type || "\u2014"}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        {addSearchResults.length === 0 && !addLoading && (
                                            <div style={{color: "#6c757d", fontSize: ".8125rem"}}>Нет результатов. Укажите период и нажмите Найти.</div>
                                        )}
                                    </div>
                                )}

                                <div style={{marginTop: 16, display: "flex", gap: 8, justifyContent: "flex-end"}}>
                                    <button className={classes.BtnOutline} onClick={function () { setShowAddModal(false); }}>Отмена</button>
                                    <button
                                        className={classes.BtnPrimary || classes.BtnOutline}
                                        disabled={addLoading}
                                        onClick={function () {
                                            var ids = [];
                                            if (addMode === "id") {
                                                ids = addIdInput.split(",").map(function (s) { return parseInt(s.trim(), 10); }).filter(function (n) { return !isNaN(n) && n > 0; });
                                            } else {
                                                ids = Object.keys(addSelectedIds).map(Number);
                                            }
                                            if (ids.length === 0) {
                                                onMessage({type: "error", message: "Не выбрано ни одной транзакции"});
                                                return;
                                            }
                                            onAddTransactions(ids);
                                        }}
                                    >
                                        {addLoading ? "Добавление..." : "Добавить"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {cancelId === s.id && (
                        <div className={classes.DetailCard} style={{marginTop: 16, background: "#fff3cd", borderColor: "#ffc107"}}>
                            <h6 style={{margin: "0 0 8px 0", fontWeight: 600, color: "#856404"}}>Подтверждение отмены</h6>
                            <div className={classes.CancelInput}>
                                <label style={{display: "block", fontSize: ".8125rem", marginBottom: 4}}>
                                    Причина отмены:
                                </label>
                                <textarea
                                    value={cancelReason}
                                    onChange={function (e) { setCancelReason(e.target.value); }}
                                    placeholder="Укажите причину отмены..."
                                />
                            </div>
                            <div style={{marginTop: 8, display: "flex", gap: 8}}>
                                <button
                                    className={classes.BtnDanger}
                                    onClick={onCancel}
                                    disabled={cancelling}
                                >
                                    {cancelling ? "Отмена..." : "Подтвердить отмену"}
                                </button>
                                <button
                                    className={classes.BtnOutline}
                                    onClick={function () { setCancelId(null); setCancelReason(""); }}
                                >
                                    Отмена
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // Render create wizard
    function renderCreateWizard() {
        return (
            <div className={classes.Card}>
                <div className={classes.Header}>
                    <h5 className={classes.Title}>Новый расчёт</h5>
                    <button className={classes.BtnOutline} onClick={closeCreateWizard}>Закрыть</button>
                </div>
                <div className={classes.Content}>
                    <div className={classes.WizardStep}>
                        <div className={classes.WizardStepTitle}>Шаг 1: Выберите терминал и период</div>
                        <div className={classes.FormRow}>
                            <div className={classes.FormGroup} style={{flex: 2}}>
                                <MerchantTerminalSelect
                                    mode="admin"
                                    token={token}
                                    onSelect={function(val) { setCreateTerminalId(val); }}
                                />
                            </div>
                        </div>
                        <div className={classes.FormRow}>
                            <div className={classes.FormGroup} style={{flex: 2}}>
                                <DateRange onSelectDate={function(range) { setCreateDateRange(range); }} defaultPeriod={null}/>
                            </div>
                        </div>
                        <div style={{fontSize: ".75rem", color: "#6c757d", marginBottom: 8}}>
                            Фильтрация по дате завершения транзакции
                        </div>
                        <div className={classes.FormRow}>
                            <div className={classes.FormGroup} style={{flex: 2}}>
                                <label>Комментарий</label>
                                <textarea
                                    rows={3}
                                    value={createComment}
                                    onChange={function (e) { setCreateComment(e.target.value); }}
                                    placeholder="Необязательный комментарий"
                                    style={{width: "100%"}}
                                />
                            </div>
                        </div>
                        <div className={classes.FormRow}>
                            <div className={classes.FormGroup}>
                                <label>Курс USDT</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={createUsdtRate}
                                    onChange={function (e) { setCreateUsdtRate(e.target.value); }}
                                    placeholder="Например: 92.50"
                                />
                                {createUsdtRate && previewData && previewData.transactions && (function () {
                                    var net = 0;
                                    previewData.transactions.forEach(function (tx) {
                                        if (!excludedIds[tx.id]) net += (tx.amount - (tx.fee || 0));
                                    });
                                    return net > 0 ? (
                                        <div style={{fontSize: ".75rem", color: "#6c757d", marginTop: 4}}>
                                            {"Сумма USDT: " + (net / 100 / Number(createUsdtRate)).toFixed(2)}
                                        </div>
                                    ) : null;
                                })()}
                            </div>
                            <div className={classes.FormGroup}>
                                <label>Файл подтверждения</label>
                                <input
                                    type="file"
                                    onChange={function (e) { setCreateFile(e.target.files[0] || null); }}
                                />
                            </div>
                        </div>
                        <div style={{marginTop: 12}}>
                            <button
                                className={classes.BtnPrimary}
                                onClick={onPreview}
                                disabled={previewLoading || !createTerminalId}
                            >
                                {previewLoading ? "Загрузка..." : "Предпросмотр"}
                            </button>
                        </div>
                    </div>

                    {previewData && (function () {
                        var allTxs = Array.isArray(previewData.transactions) ? previewData.transactions : [];
                        var excludedCount = Object.keys(excludedIds).filter(function (k) { return excludedIds[k]; }).length;
                        var includedTxs = allTxs.filter(function (tx) { return !excludedIds[tx.id]; });
                        var calcAmount = 0;
                        var calcFee = 0;
                        includedTxs.forEach(function (tx) {
                            calcAmount += tx.amount;
                            calcFee += (tx.fee || 0);
                        });
                        var allChecked = excludedCount === 0;

                        return (
                        <div className={classes.WizardStep}>
                            <div className={classes.WizardStepTitle}>Шаг 2: Проверьте и подтвердите</div>

                            <div className={classes.PreviewSummary}>
                                <h6>Итого</h6>
                                <div className={classes.DetailGrid}>
                                    <div>
                                        <div className={classes.DetailLabel}>Транзакций</div>
                                        <div className={classes.DetailValue}>
                                            {includedTxs.length}
                                            {excludedCount > 0 && (
                                                <span style={{fontSize: ".75rem", color: "#999", marginLeft: 6}}>
                                                    {"(исключено: " + excludedCount + ")"}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <div className={classes.DetailLabel}>Сумма</div>
                                        <div className={classes.DetailValue}>
                                            {formatAmount(calcAmount)} &#8381;
                                        </div>
                                    </div>
                                    <div>
                                        <div className={classes.DetailLabel}>Комиссия</div>
                                        <div className={classes.DetailValue}>
                                            {formatAmount(calcFee)} &#8381;
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {allTxs.length > 0 && (
                                <div style={{maxHeight: 400, overflowY: "auto", marginBottom: 16}}>
                                    <table className={classes.Table}>
                                        <thead>
                                        <tr>
                                            <th style={{width: 40, textAlign: "center"}}>
                                                <input
                                                    type="checkbox"
                                                    checked={allChecked}
                                                    onChange={function () {
                                                        if (allChecked) {
                                                            var newExcluded = {};
                                                            allTxs.forEach(function (tx) { newExcluded[tx.id] = true; });
                                                            setExcludedIds(newExcluded);
                                                        } else {
                                                            setExcludedIds({});
                                                        }
                                                    }}
                                                />
                                            </th>
                                            <th>ID</th>
                                            <th>Сумма</th>
                                            <th>Комиссия</th>
                                            <th>Дата</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {allTxs.map(function (tx) {
                                            var isExcluded = !!excludedIds[tx.id];
                                            return (
                                                <tr key={tx.id} className={isExcluded ? classes.ExcludedRow : ""}>
                                                    <td style={{textAlign: "center"}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={!isExcluded}
                                                            onChange={function () {
                                                                var updated = Object.assign({}, excludedIds);
                                                                if (isExcluded) {
                                                                    delete updated[tx.id];
                                                                } else {
                                                                    updated[tx.id] = true;
                                                                }
                                                                setExcludedIds(updated);
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{tx.id}</td>
                                                    <td>{formatAmount(tx.amount)} &#8381;</td>
                                                    <td>{formatAmount(tx.fee)} &#8381;</td>
                                                    <td>{formatDate(tx.date)}</td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            <div style={{display: "flex", gap: 8}}>
                                <button
                                    className={classes.Btn}
                                    onClick={onCreate}
                                    disabled={creating || includedTxs.length === 0}
                                >
                                    {creating ? "Создание..." : "Создать расчёт"}
                                </button>
                                <button
                                    className={classes.BtnOutline}
                                    onClick={function () { setPreviewData(null); setExcludedIds({}); }}
                                >
                                    Назад
                                </button>
                            </div>
                        </div>
                        );
                    })()}
                </div>
            </div>
        );
    }

    // Render list view
    function renderList() {
        return (
            <div className={classes.Card}>
                <div className={classes.Header}>
                    <h5 className={classes.Title}>Расчёты</h5>
                    <button className={classes.Btn} onClick={openCreateWizard}>
                        + Создать расчёт
                    </button>
                </div>

                <div className={classes.FilterBar}>
                    <div style={{flex: 1}}>
                        <MerchantTerminalSelect
                            mode="admin"
                            token={token}
                            stackOnMobile={true}
                            onSelect={function(val) { setTerminalId(val); setPage(1); }}
                        />
                    </div>
                    <select
                        value={statusFilter}
                        onChange={function (e) { setStatusFilter(e.target.value); setPage(1); }}
                    >
                        <option value="">Все статусы</option>
                        <option value="0">Создан</option>
                        <option value="1">Подтверждён</option>
                        <option value="2">Отменён</option>
                    </select>
                </div>

                {loading ? (
                    <div className={classes.Empty}>Загрузка...</div>
                ) : settlements.length === 0 ? (
                    <div className={classes.Empty}>Расчёты не найдены</div>
                ) : (
                    <React.Fragment>
                    <table className={classes.Table}>
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Мерчант</th>
                            <th>Терминал</th>
                            <th>Сумма</th>
                            <th>Транзакций</th>
                            <th>Статус</th>
                            <th>Дата</th>
                            <th>Создал</th>
                        </tr>
                        </thead>
                        <tbody>
                        {settlements.map(function (s) {
                            return (
                                <tr key={s.id} onClick={function () { onRowClick(s); }}>
                                    <td>{s.id}</td>
                                    <td>{s.merchant_name || "\u2014"}</td>
                                    <td>{s.terminal_name ? (s.terminal_name + " (#" + (s.terminal_id || s.terminalId) + ")") : (s.terminal_id || s.terminalId || "\u2014")}</td>
                                    <td>{formatAmount(s.amount)} &#8381;</td>
                                    <td>{s.transactions_count || s.transactionsCount || 0}</td>
                                    <td>
                                        <span className={getStatusBadgeClass(s.status)}>
                                            {STATUS_LABELS[s.status] || "?"}
                                        </span>
                                    </td>
                                    <td>{formatDate(s.created_at || s.createdAt)}</td>
                                    <td>{(s.created_by && s.created_by.username) || s.createdBy || "\u2014"}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>

                    <div className={classes.MobileList}>
                        {settlements.map(function (s) {
                            return (
                                <button
                                    key={s.id}
                                    type="button"
                                    className={classes.MobileCard}
                                    onClick={function () {
                                        onRowClick(s);
                                    }}
                                >
                                    <div className={classes.MobileCardRow}>
                                        <div className={classes.MobilePrimary}>#{s.id}</div>
                                        <span className={getStatusBadgeClass(s.status)}>
                                            {STATUS_LABELS[s.status] || '?'}
                                        </span>
                                    </div>
                                    <div className={classes.MobileCardRow}>
                                        <div className={classes.MobileSecondary}>{s.merchant_name || '\u2014'}</div>
                                        <div className={classes.MobileMuted}>{formatDate(s.created_at || s.createdAt)}</div>
                                    </div>
                                    <div className={classes.MobileCardRow}>
                                        <div className={classes.MobileTertiary}>
                                            {s.terminal_name
                                                ? s.terminal_name + ' (#' + (s.terminal_id || s.terminalId) + ')'
                                                : s.terminal_id || s.terminalId || '\u2014'}
                                        </div>
                                        <div className={classes.MobileAmount}>{formatAmount(s.amount)} &#8381;</div>
                                    </div>
                                    <div className={classes.MobileCardFooter}>
                                        <span>Транзакций: {s.transactions_count || s.transactionsCount || 0}</span>
                                        <span>{(s.created_by && s.created_by.username) || s.createdBy || '\u2014'}</span>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                    </React.Fragment>
                )}

                {perPage < count && (
                    <div className={classes.PaginationWrap}>
                        <Pagination
                            firstPageText={"\u21E4"}
                            prevPageText={"\u21E0"}
                            lastPageText={"\u21E5"}
                            nextPageText={"\u21E2"}
                            activeLinkClass={classes.ActiveLink}
                            activePage={page}
                            itemsCountPerPage={perPage}
                            totalItemsCount={count}
                            pageRangeDisplayed={5}
                            onChange={function (p) { setPage(p); }}
                        />
                    </div>
                )}
            </div>
        );
    }

    // Determine which view to show
    var content;
    if (showCreate) {
        content = renderCreateWizard();
    } else if (selectedSettlement) {
        content = renderDetail();
    } else {
        content = renderList();
    }

    return (
        <Wrapper>
            <Container>
                <Column width="full">{content}</Column>
            </Container>
        </Wrapper>
    );
});

export default Settlement;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/Settlement/index.js